<swal #warnDateValidAlert
  title="Warning" i18n-title
  text="Invalid Date" i18n-text
  icon="warning"
  html=""
  [swalOptions]="swalOptions">
</swal>
<form [formGroup]="incentiveForm" novalidate>
  <div fxLayout="row" fxLayoutWrap>
    <div class="formfields__container" fxFlex="33">
      <mat-form-field>
        <label><span i18n>Incentive Type</span> <span class="required">*</span></label>
        <mat-select id="incentive-type-{{index}}" formControlName="incentive_type" placeholder="Select One"
          i18n-placeholder>
          <mat-option *ngFor="let incentiveType of incentiveTypes" [value]="incentiveType.value">
            <span id="incentive-type-{{incentiveType.value}}">{{ incentiveType.label }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="formfields__container no-padding-right" fxFlex="33">
      <iv-currency-field
        label="Incentive Amount" i18n-label
        controlName="incentive_amount-{{index}}"
        [formControl]="incentiveForm.get('incentive_amount')"
        [formFieldClass]="'unset-margin-label'"
      ></iv-currency-field>
    </div>

    <ng-container *ngIf="showFitOutOptions()">
      <div class="formfields__container" fxFlex="30">
        <mat-form-field floatPlaceholder="never">
          <label i18n>Date Applied</label>
          <input
            matInput
            id="incentive-date-{{index}}"
            formControlName="date_applied"
            [matDatepicker]="incentiveDatepicker"
            [placeholder]="!incentive.date_applied && getUserCountry !== 'JPN' ? 'DD/MM/YYYY'
            : !incentive.date_applied && getUserCountry === 'JPN'? 'YYYY/MM/DD' : ''"
            floatPlaceholder="never"
            (blur)="validateDate($event)"
            (dateChange)="validateDate($event)" />
          <mat-datepicker-toggle matSuffix [for]="incentiveDatepicker">
            <mat-icon>date_range</mat-icon>
          </mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #incentiveDatepicker></mat-datepicker>
      </div>
    </ng-container>

    <ng-container *ngIf="showFreeRentOptions()">
      <div class="formfields__container" fxFlex="30">
        <iv-decimal-field
          label="Number of Months" i18n-label
          controlName="incentive-no-of-months-{{index}}"
          [integerLimit]="3"
          [formControl]="incentiveForm.get('no_of_months')">
        </iv-decimal-field>
      </div>
    </ng-container>

    <ng-container *ngIf="showOtherOptions()">
      <div class="formfields__container" fxFlex="30">
        <mat-form-field floatLabel="never">
          <label i18n>Description</label>
          <input
            id="incentive-description-{{index}}"
            matInput
            type="text"
            maxlength="254"
            formControlName="description"
            placeholder="Enter note here..." i18n-placeholder />
        </mat-form-field>
      </div>
    </ng-container>

    <div fxFlex="5">
      <iv-delete [identifier]="incentive.id" (deleteEvent)="deleteIncentive($event)"></iv-delete>
    </div>
  </div>
</form>
